import React from "react";
import LinkIcon from "@mui/icons-material/Link";
import { Box } from "@mui/material";

import { IEntriesData } from "../../api/compliance/index.types";
import { CopyToClipboard } from "../../components/ui";
import { getTimeByTimeZone } from "../../utils/moment";

export const getQueryStringByStringValues = (by: string, values: string): string => {
  const arrayValues = values.trim().split(/[\s,]+/);
  const query = new URLSearchParams();
  arrayValues.forEach((val) => {
    query.append(by, val);
  });

  return query.toString();
};

export const appendCommaSeparatedValuesToQuery = (
  value: string,
  query: URLSearchParams,
  queryKey: string
): void => {
  value
    .trim()
    .replaceAll(", ", ",")
    .split(",")
    .forEach((val) => {
      query.append(queryKey, val.trim());
    });
};

export const appendSearchParamsToQuery = (
  search: Record<string, string>,
  query: URLSearchParams,
  multipleValues: string[] = ["names", "email", "compliance_entries_id"]
): void => {
  for (const [key, val] of Object.entries(search)) {
    if (val) {
      if (multipleValues.includes(key)) {
        appendCommaSeparatedValuesToQuery(val, query, key);
      } else {
        query.append(key, val);
      }
    }
  }
};

export const getSelectedRowsData = (
  selectedRows: Record<"id", number>[],
  data: IEntriesData[]
): IEntriesData[] => {
  return data.filter((r) => selectedRows.find((selected) => r.id === selected.id));
};

const CellValue: React.FC<{ value: string }> = ({ value }) => {
  return (
    <Box display="flex" alignItems="center">
      <a rel="noopener noreferrer" target="_blank" href={value}>
        <LinkIcon />
      </a>
      <CopyToClipboard value={value} useIcon />
    </Box>
  );
};

interface ICellValueProps {
  value: string;
}
export const RenderCellValue: React.FC<ICellValueProps> = ({ value }) => {
  if (!value) return null;

  if (value.includes(",")) {
    const values = value.split(",");
    return (
      <>
        {values.map((v, i) => (
          <CellValue value={v} key={v + i} />
        ))}
      </>
    );
  }

  return <CellValue value={value} />;
};

export const replaceCommaAndNewLineSymbols = (value: string): string => {
  if (value) {
    return value.replaceAll(",", " ; ").replaceAll("\n", " ");
  }
  return "";
};
export const replaceNewLineAndTrim = (value: string): string => {
  if (value) {
    return value.replaceAll("\n", " ").trim();
  }
  return "";
};

interface ITitleUpdated {
  value: string | undefined | null;
}
export const TitleUpdated: React.FC<ITitleUpdated> = ({ value }) => {
  if (value) {
    return (
      <>
        Updated at: <b>{getTimeByTimeZone(value)}</b>
      </>
    );
  }
  return null;
};
